import React, { useState } from "react";
import pumpGlow from "../resources/button_blue_gradient_glow.png";
import powerIcon from "../resources/icon_power.png";

const PumpSingleSpeedModal = ({
    onClose,
    pumpName,
    pumpNumber,
    pumpStatus,
    hasAuto,
    sendPumpCommand
}) => {

    const [mode, setMode] = useState(pumpStatus);

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 999,
            }}
            onClick={onClose}
        >
            {/* Popup container */}
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: "320px",
                    backgroundColor: "#1E1E1E",
                    borderRadius: "16px",
                    padding: "24px",
                    boxShadow: "0 0 20px rgba(0,0,0,0.7)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    animation: "fadeIn 0.2s ease-out",
                }}
            >
                {/* Title */}
                <div
                    style={{
                        color: "white",
                        fontSize: "22px",
                        marginBottom: "25px",
                        textAlign: "center",
                    }}
                >
                    {pumpName}
                </div>

                {/* Button container */}
                <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                    {/* ---- OFF ---- */}
                    <div
                        onClick={() => {
                            setMode("off");
                            sendPumpCommand(pumpNumber, "off");
                            onClose();
                        }}
                        style={{
                            position: "relative",
                            width: "80%",
                            height: "100px",
                            margin: "0 auto",
                            marginTop: "-20px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {/* Glow background */}
                        <img
                            src={pumpGlow}
                            alt="Glow"
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                width: "130%",
                                height: "130%",
                                transform: "translate(-50%, -50%)",
                                objectFit: "contain",
                                pointerEvents: "none",
                                zIndex: 0,
                                opacity: mode === 2 ? 1 : 0,
                                transition: "opacity 0.3s",
                                filter: "brightness(1.2)",
                            }}
                        />

                        {/* Button */}
                        <button
                            style={{
                                width: "100%",
                                height: "60px",
                                background: "transparent",
                                border: mode === 2 ? "none" : "2px solid #2f3338",
                                borderRadius: "30px",
                                color: "white",
                                fontSize: "20px",
                                cursor: "pointer",
                                zIndex: 1,
                                transition: "border 0.3s",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center", // center the inner container
                            }}
                        >
                            {/* Icon + Text wrapper */}
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <img
                                    src={powerIcon}
                                    alt="Power"
                                    style={{
                                        width: "30px",
                                        height: "30px",
                                        filter: "brightness(1000%)",
                                    }}
                                />
                                <span>Off</span>
                            </div>
                        </button>
                    </div>


                    {/* ---- AUTO ---- */}
                    <div
                        onClick={() => {
                            setMode("auto");
                            sendPumpCommand(pumpNumber, "auto");
                            onClose();
                        }}
                        style={{
                            position: "relative",
                            width: "80%",
                            height: "100px",
                            margin: "0 auto",
                            display: "flex",
                            marginTop: "-10px",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {/* Glow background */}
                        <img
                            src={pumpGlow}
                            alt="Glow"
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                width: "125%",
                                height: "110%",
                                transform: "translate(-50%, -50%)",
                                pointerEvents: "none",
                                zIndex: 0,
                                opacity: mode === 3 ? 1 : 0,
                                transition: "opacity 0.3s",
                            }}
                        />

                        {/* Actual button */}
                        <button
                            style={{
                                width: "100%",
                                height: "60px",
                                background: "transparent",
                                border: mode === 3 ? "none" : "2px solid #2f3338", // remove border when glow is active
                                borderRadius: "30px",
                                color: "white",
                                fontSize: "20px",
                                cursor: "pointer",
                                zIndex: 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "border 0.3s",
                            }}
                        >
                            Auto
                        </button>
                    </div>

                    {/* ---- ON ---- */}
                    <div
                        onClick={() => {
                            setMode("on");
                            sendPumpCommand(pumpNumber, "on");
                            onClose();
                        }}
                        style={{
                            position: "relative",
                            width: "80%",
                            height: "100px",
                            margin: "0 auto",
                            display: "flex",
                            marginTop: "-10px",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {/* Glow background */}
                        <img
                            src={pumpGlow}
                            alt="Glow"
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                width: "125%",
                                height: "110%",
                                transform: "translate(-50%, -50%)",
                                objectFit: "contain",
                                pointerEvents: "none",
                                zIndex: 0,
                                opacity: mode === 1 ? 1 : 0,
                                transition: "opacity 0.3s",
                            }}
                        />

                        {/* Button */}
                        <button
                            style={{
                                width: "100%",
                                height: "60px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "transparent",
                                border: mode === 1 ? "none" : "2px solid #2f3338",
                                borderRadius: "30px",
                                color: "white",
                                fontSize: "20px",
                                cursor: "pointer",
                                zIndex: 1,
                                transition: "border 0.3s",
                            }}
                        >
                            <span>On</span>
                        </button>
                    </div>

                </div>

                {/* Close Button */}
                <button
                    onClick={onClose}
                    style={{
                        marginTop: "20px",
                        backgroundColor: "#2B333C",
                        border: "none",
                        borderRadius: "30px",
                        color: "white",
                        fontSize: "16px",
                        padding: "10px 30px",
                        cursor: "pointer",
                    }}
                >
                    Close
                </button>

                {/* Animations */}
                <style>
                    {`
            @keyframes fadeIn {
              from { opacity: 0; transform: scale(0.95); }
              to { opacity: 1; transform: scale(1); }
            }
          `}
                </style>
            </div>
        </div>
    );
};

export default PumpSingleSpeedModal;
